import '@Global/user';
import '@Global/modal';
import '@Global/colorpicker';
import '@Global/loading-toast';
import '@Global/email-wizard';
import '@Global/auto-branding';
import '@Global/email-campaign-ai-content';
import '@Global/admin-save-section-template-panel';
import '@Global/color-palette-panel';
import '@Global/brand-kit-palette-editor';
import '@Global/email-maker-block-manager';
import '@Global/toast';

import type {ReactElement} from 'react';
import {ModalContainer} from '@Components/modal-container';
import ModalContainerDeprecated from '@Components/modal-container-deprecated';
import {LoadingToast} from '@Components/loading-toast';
import {MessageGrowl} from '@Components/message-growl';
import App from '@Components/app';
import '@/email-maker/main';
import {renderApp} from '@Utils/renderApp.util';

export function EmailMakerApp(): ReactElement {
  return (
    <App>
      <ModalContainerDeprecated />
      <ModalContainer />
      <LoadingToast />
      <MessageGrowl />
    </App>
  );
}

renderApp(<EmailMakerApp />, 'email-maker-app');